import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import RootErrorBoundary from './components/commons/RootErrorBoundary';
import { scheduleSentryInit } from './utils/initSentry';

import './style/style.css';
import './style/main.css';

scheduleSentryInit();

ReactDOM.render(
  <RootErrorBoundary>
    <App />
  </RootErrorBoundary>,
  document.getElementById('root'),
);
